import React from "react";

/**
 * ResumenPaciente
 *
 * Resumen clínico + operativo del paciente.
 * ❌ NO repite datos del header
 * ❌ NO renderiza historia larga
 * ✅ Solo información de “un glance”
 */

const ResumenPaciente = ({ historiaClinica, recetas }) => {

  return (
    <section className="paciente-folder resumen-paciente">
      <h2>Resumen</h2>

      {/* ===============================
          BLOQUE CLÍNICO
          =============================== */}
      <div className="resumen-bloque">
        <div className="resumen-item">
          <span className="resumen-label">Alergias</span>
          <span className="resumen-valor">
            {historiaClinica?.["antecedentes.personalesPatologicos.alergias"] || "No referidas"}
          </span>
        </div>

        <div className="resumen-item">
          <span className="resumen-label">Enfermedades crónico-degenerativas</span>
          <span className="resumen-valor">
            {historiaClinica?.["antecedentes.personalesPatologicos.ECD"] || "Ninguna referida"}
          </span>
        </div>

        <div className="resumen-item">
          <span className="resumen-label">Hemotipo</span>
          <span className="resumen-valor">
            {historiaClinica?.["antecedentes.personalesPatologicos.hemotipo"] || "No registrado"}
          </span>
        </div>

        <div className="resumen-item">
          <span className="resumen-label">Diagnóstico última consulta</span>
          <span className="resumen-valor">
            {(() => {
              if (!historiaClinica) return "Sin consultas previas";

              const inicialFecha = historiaClinica.fechaConsulta;
              const inicialDiagnostico = historiaClinica.diagnostico;

              const segs = Array.isArray(historiaClinica.consultas)
                ? historiaClinica.consultas
                : [];

              if (!segs.length) return inicialDiagnostico || "Sin consultas previas";

              const last = [...segs].sort(
                (a, b) => new Date(b.fechaConsulta) - new Date(a.fechaConsulta)
              )[0];

              return (
                (inicialFecha &&
                  new Date(inicialFecha) > new Date(last.fechaConsulta)
                    ? inicialDiagnostico
                    : last.diagnostico) || "No registrado"
              );
            })()}
          </span>
        </div>

        <div className="resumen-item">
          <span className="resumen-label">Tratamiento última consulta</span>
          <span className="resumen-valor">
            {(() => {
            if (!historiaClinica) return "No registrado";

            const inicialFecha = historiaClinica.fechaConsulta;
            const inicialTratamiento = historiaClinica.tratamiento;

            const segs = Array.isArray(historiaClinica.consultas)
              ? historiaClinica.consultas
              : [];

            if (!segs.length) return inicialTratamiento || "No registrado";

            const last = [...segs].sort(
              (a, b) => new Date(b.fechaConsulta) - new Date(a.fechaConsulta)
            )[0];

            return (
                (inicialFecha &&
                  new Date(inicialFecha) > new Date(last.fechaConsulta)
                    ? inicialTratamiento
                    : last.tratamiento) || "No registrado"
              );
          })()}
          </span>
        </div>
      </div>

      {/* ===============================
          BLOQUE OPERATIVO
          =============================== */}
      <div className="resumen-bloque resumen-operativo">
        <div className="resumen-item">
          <span className="resumen-label">Consultas</span>
          <span className="resumen-valor">
            {historiaClinica
              ? (historiaClinica.fechaConsulta ? 1 : 0) +
                (Array.isArray(historiaClinica.consultas)
                  ? historiaClinica.consultas.length
                  : 0)
              : 0}
          </span>
        </div>

        <div className="resumen-item">
          <span className="resumen-label">Recetas</span>
          <span className="resumen-valor">
            {Array.isArray(recetas) ? recetas.length : 0}
          </span>
        </div>

        <div className="resumen-item">
          <span className="resumen-label">Tipo de paciente</span>
          <span className="resumen-valor">
            {historiaClinica &&
            ((historiaClinica.fechaConsulta ? 1 : 0) +
              (Array.isArray(historiaClinica.consultas)
                ? historiaClinica.consultas.length
                : 0)) > 1
            ? "Recurrente"
            : "Nuevo"}
          </span>
        </div>
      </div>
    </section>
  );
};

export default ResumenPaciente;
